<template>
    <f7-page>
        <f7-navbar>
            <f7-nav-left back-link="Atrás" sliding></f7-nav-left>
            <f7-nav-title>{{anime.titulo}}</f7-nav-title>
            <f7-nav-right>
                <f7-link v-if="anime.esFavorito">
                    <i class="material-icons addToFav" @click="favorito()">star</i>
                </f7-link>
                <f7-link v-else>
                    <i class="material-icons addToFav" @click="favorito()">star_border</i>
                </f7-link>
            </f7-nav-right>
        </f7-navbar>


        <f7-toolbar bottom tabbar id="toolbar" class="tabbar-labels">
            <f7-link class="bottom-tab" tab-link="#ficha" tab-link-active>
                <i class="material-icons">schedule</i>
                <span class="tabbar-label">Ficha</span>
            </f7-link>
            <f7-link class="bottom-tab" tab-link="#episodios">
                <i class="material-icons">toc</i>
                <span class="tabbar-label">Episodios</span>
            </f7-link>

        </f7-toolbar>
        <f7-tabs class="tabs" swipeable>
            <f7-tab id="ficha" class="" tab-active style="margin:0px;height:100%;overflow:auto;">
                <f7-card>
                    <f7-card-content :padding="true">
                        <f7-row>
                            <f7-col width="40">
                                <f7-block>
                                    <img :src="anime.imagen" height="150px"
                                         width="auto"/>
                                </f7-block>
                            </f7-col>
                            <f7-col width="60">
                                <p>
                                    <b>Titulo: </b>{{anime.titulo}}<br/>
                                    <b>Tipo: </b>{{anime.tipo}}<br/>
                                    <b>Estado: </b>{{anime.concluido}}<br/>
                                    <b>Episodios: </b>{{anime.episodios.length}}<br/>
                                    <b>Generos: </b>
                                    <span v-for="(genero, index) in anime.generos">
                                            <f7-link :href="'/animes/genero/' + genero">
                                                {{genero}}
                                            </f7-link>,
                                        </span>
                                    <br/>
                                </p>
                            </f7-col>
                        </f7-row>
                    </f7-card-content>
                </f7-card>
                <f7-card>
                    <f7-card-content :padding="true">
                        {{anime.sinopsis}}
                    </f7-card-content>
                </f7-card>
            </f7-tab>
            <f7-tab id="episodios" class="" style="margin:0px;height:100%;overflow:auto;">

                <f7-list media-list inset style="margin:0px;height:100%;overflow:auto;">
                    <f7-list-item v-for="(ep, index) in anime.episodios"
                                  :link="'/anime/' + id + '/episodio/' + ep.idEpisodio"
                                  :key="index"
                                  title=""
                                  :subtitle="'Episodio ' + ep.Episodio">
                        <img slot="media" :src="ep.Fotograma" width="80"/>
                    </f7-list-item>
                </f7-list>

            </f7-tab>
        </f7-tabs>


    </f7-page>
</template>
<script>

    export default {
        components: {},
        props: ['id'],
        data() {
            return {
                anime: {
                    titulo: '',
                    imagen: '',
                    tipo: '',
                    concluido: '',
                    episodios: [],
                    generos: '',
                    sinopsis: '',
                    esFavorito: false,
                }
            }
        },
        methods: {
            favorito() {
                let self = this;
                let app = this.$f7;
                app.preloader.show();
                let action = "addFavorito";
                if (this.anime.esFavorito) {
                    action = "removeFavorito";
                }
                app.request.json('https://www.jkanimeapp.com/ios/api.php?action=' + action + '&idAnime=' + self.anime.idanime, function (data) {
                    app.preloader.hide();
                    self.anime.esFavorito = !self.anime.esFavorito;
                    app.toast.create({
                        text: 'Información actualizada',
                        closeTimeout: 2000,
                    }).open();
                });
            }
        },
        mounted() {
            let self = this;
            let app = this.$f7;
            let idAnime = this.id;
            app.preloader.show();
            app.request.json('https://www.jkanimeapp.com/ios/api.php?action=verFicha&idAnime=' + idAnime, function (data) {
                app.preloader.hide();
                self.anime = data.response;
            });

        }
    };
</script>
